import React from 'react';
import Popper from '@material-ui/core/Popper';
import Grow from '@material-ui/core/Grow';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import WhatsApp from '@material-ui/icons/WhatsApp';
import CloseRounded from '@material-ui/icons/CloseRounded';

import classes from './classes.module.css';
import { guc } from '../../../Localisation';
import { isEmptyString, path } from '../../../../utils';
import { EVENT_CATEGORIES, EVENT_ACTIONS, logEvent } from '../../../Analytics';
import { getBrandLogo, getBrandTitle, getMessageContent, getMessageTitle, getCtaText, getRedirectLink, getBrandDescription, getThemeColor, getHeaderColor, getHeaderTextColor, getPhoneNumber, getChatBoxBackground } from './utils';

export default class WhatsAppWidget extends React.PureComponent {

    state = {
        isEnabled: false,
        popperOpen: false,
        popperAnchor: null,
    }

    componentDidMount = () => {
        try {
            const data = JSON.parse(guc('whatsapp_widget_data', '{}'));
            this.setState({ isEnabled: !isEmptyString(getPhoneNumber(data)), data });
        } catch (e) {
            console.log('JSON parse error on whatsapp_widget_data');
        }
    }

    closePopper = () => this.setState({ popperOpen: false, popperAnchor: null });

    renderPopper = () => this.state.isEnabled && <Popper open={this.state.popperOpen} anchorEl={this.state.popperAnchor} transition className={classes.popper} placement='top-end'>
        {({ TransitionProps }) => <ClickAwayListener onClickAway={this.closePopper}>
            <Grow {...TransitionProps} style={{ transformOrigin: '100% 100%' }}>{this.renderChatBox()}</Grow>
        </ClickAwayListener>}
    </Popper>;

    renderChatBox = () => {
        const { data } = this.state;
        return <div className={classes.box} style={{ background: `url(${getChatBoxBackground(data)})` }}>
            <div className={classes.header} style={{ backgroundColor: getHeaderColor(data) }}>
                <img src={getBrandLogo(data)} className={classes.brandLogo} />
                <div className={classes.headerText} style={{ color: getHeaderTextColor(data) }}>
                    <div className={classes.title}>{getBrandTitle(data)}</div>
                    <div className={classes.description}>{getBrandDescription(data)}</div>
                </div>
                <CloseRounded className={classes.closeIcon} style={{ color: getHeaderTextColor(data) }} onClick={this.closePopper} />
            </div>
            <div className={classes.bodyWrapper}>
                <div className={classes.body}>
                    <div className={classes.title}>{getMessageTitle(data)}</div>
                    <div className={classes.message}>{getMessageContent(data).map(_ => <div key={_}>{_}</div>)}</div>
                </div>
            </div>
            <div className={classes.footer}>
                <a className={classes.startButton} style={{ backgroundColor: getThemeColor(data) }} role='button' target='_blank' title='WhatsApp' href={getRedirectLink(data)} onClick={this.onStartChatClicked}>
                    <WhatsApp className={classes.icon} />
                    {getCtaText(data)}
                </a>
            </div>
        </div>;
    }

    onStartChatClicked = () => logEvent(EVENT_CATEGORIES.WHATSAPP_WIDGET, EVENT_ACTIONS.START_CHAT_CLICKED);

    onWidgetClick = e => {
        logEvent(EVENT_CATEGORIES.WHATSAPP_WIDGET, EVENT_ACTIONS.CLICKED);
        this.setState({ popperOpen: true, popperAnchor: e.currentTarget });
    }

    render = () => <Grow in={this.state.isEnabled}><div className={classes.buttonContainer}>
        <div className={classes.button} onClick={this.onWidgetClick} style={{ backgroundColor: getThemeColor(this.state.data) }}>
            <WhatsApp className={classes.icon} />
        </div>
        {this.renderPopper()}
    </div></Grow>;

}